import Country from '~/Api/Country/Country';

export default class ReferenceBasketVersion {
	public readonly description?: string;

	public readonly id: string;

	public readonly referenceCountries?: Country[];

	public readonly sinceDate: Date;

	public constructor(id: string, description: string, sinceDate: Date, referenceCountries: Country[]) {
		this.id = id;
		this.description = description;
		this.sinceDate = sinceDate;
		this.referenceCountries = referenceCountries;
	}
}
